// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notificationToast_notificationToast__I1CV3 {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px 16px;
  min-width: 320px;
  max-width: 400px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 4px solid #6b7280;
}
.notificationToast_notificationToast__I1CV3:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
.notificationToast_notificationToast__I1CV3:focus {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}
.notificationToast_notificationToast__I1CV3.notificationToast_high__yIx9Z {
  border-left-color: #F44336;
}
.notificationToast_notificationToast__I1CV3.notificationToast_medium__s1sI1 {
  border-left-color: #FF9B21;
}
.notificationToast_notificationToast__I1CV3.notificationToast_low__iMT7f {
  border-left-color: #2563eb;
}

.notificationToast_iconContainer__XMQYQ {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}
.notificationToast_iconContainer__XMQYQ img, .notificationToast_iconContainer__XMQYQ svg, .notificationToast_iconContainer__XMQYQ div {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.notificationToast_content__Gyqaa {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.notificationToast_header__Z5wA4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.notificationToast_title__J\\+iUC {
  font-weight: 600;
  font-size: 14px;
  color: #1f2937;
  line-height: 1.4;
}

.notificationToast_message__FSPYX {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
  word-wrap: break-word;
}

.notificationToast_dismissBtn__YyGs1 {
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;
  color: #9ca3af;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.notificationToast_dismissBtn__YyGs1:hover {
  background: #f3f4f6;
  color: #1f2937;
}
.notificationToast_dismissBtn__YyGs1:focus {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .notificationToast_notificationToast__I1CV3 {
    transition: none;
  }
  .notificationToast_notificationToast__I1CV3:hover {
    transform: none;
  }
}
@media (max-width: 640px) {
  .notificationToast_notificationToast__I1CV3 {
    min-width: 280px;
    max-width: calc(100vw - 32px);
    padding: 10px 12px;
  }
  .notificationToast_iconContainer__XMQYQ {
    width: 36px;
    height: 36px;
    padding: 6px;
  }
  .notificationToast_title__J\\+iUC {
    font-size: 13px;
  }
  .notificationToast_message__FSPYX {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/notification/notificationToast.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,8BAAA;AACD;AACC;EACC,2BAAA;EACA,yCAAA;AACF;AAEC;EACC,0BAAA;EACA,mBAAA;AAAF;AAIC;EACC,0BAAA;AAFF;AAKC;EACC,0BAAA;AAHF;AAMC;EACC,0BAAA;AAJF;;AAQA;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AALD;AAOC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AALF;;AASA;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAND;;AASA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAND;;AASA;EACC,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAND;;AASA;EACC,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AAND;;AASA;EACC,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAND;AAQC;EACC,mBAAA;EACA,cAAA;AANF;AASC;EACC,0BAAA;EACA,mBAAA;AAPF;;AAYA;EACC;IACC,gBAAA;EATA;EAWA;IACC,eAAA;EATD;AACF;AAcA;EACC;IACC,gBAAA;IACA,6BAAA;IACA,kBAAA;EAZA;EAeD;IACC,WAAA;IACA,YAAA;IACA,YAAA;EAbA;EAgBD;IACC,eAAA;EAdA;EAiBD;IACC,eAAA;EAfA;AACF","sourcesContent":[".notificationToast {\r\n\tdisplay: flex;\r\n\talign-items: flex-start;\r\n\tgap: 12px;\r\n\tbackground: white;\r\n\tborder-radius: 8px;\r\n\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n\tpadding: 12px 16px;\r\n\tmin-width: 320px;\r\n\tmax-width: 400px;\r\n\tcursor: pointer;\r\n\ttransition: all 0.2s ease;\r\n\tborder-left: 4px solid #6b7280;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-2px);\r\n\t\tbox-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\r\n\t}\r\n\r\n\t&:focus {\r\n\t\toutline: 2px solid #2563eb;\r\n\t\toutline-offset: 2px;\r\n\t}\r\n\r\n\t// Severity-based border colors for risk alerts\r\n\t&.high {\r\n\t\tborder-left-color: #F44336;\r\n\t}\r\n\r\n\t&.medium {\r\n\t\tborder-left-color: #FF9B21;\r\n\t}\r\n\r\n\t&.low {\r\n\t\tborder-left-color: #2563eb;\r\n\t}\r\n}\r\n\r\n.iconContainer {\r\n\tflex-shrink: 0;\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tborder-radius: 50%;\r\n\tbackground-color: #f3f4f6;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tpadding: 8px;\r\n\r\n\timg, svg, div {\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tobject-fit: contain;\r\n\t}\r\n}\r\n\r\n.content {\r\n\tflex: 1;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 4px;\r\n\tmin-width: 0; // Allow text truncation\r\n}\r\n\r\n.header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tgap: 8px;\r\n}\r\n\r\n.title {\r\n\tfont-weight: 600;\r\n\tfont-size: 14px;\r\n\tcolor: #1f2937;\r\n\tline-height: 1.4;\r\n}\r\n\r\n.message {\r\n\tfont-size: 13px;\r\n\tcolor: #6b7280;\r\n\tmargin: 0;\r\n\tline-height: 1.5;\r\n\tword-wrap: break-word;\r\n}\r\n\r\n.dismissBtn {\r\n\tbackground: none;\r\n\tborder: none;\r\n\tfont-size: 20px;\r\n\tline-height: 1;\r\n\tcolor: #9ca3af;\r\n\tcursor: pointer;\r\n\tpadding: 0;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tborder-radius: 4px;\r\n\ttransition: all 0.2s ease;\r\n\tflex-shrink: 0;\r\n\r\n\t&:hover {\r\n\t\tbackground: #f3f4f6;\r\n\t\tcolor: #1f2937;\r\n\t}\r\n\r\n\t&:focus {\r\n\t\toutline: 2px solid #2563eb;\r\n\t\toutline-offset: 2px;\r\n\t}\r\n}\r\n\r\n// Reduced motion support\r\n@media (prefers-reduced-motion: reduce) {\r\n\t.notificationToast {\r\n\t\ttransition: none;\r\n\r\n\t\t&:hover {\r\n\t\t\ttransform: none;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Mobile responsive\r\n@media (max-width: 640px) {\r\n\t.notificationToast {\r\n\t\tmin-width: 280px;\r\n\t\tmax-width: calc(100vw - 32px);\r\n\t\tpadding: 10px 12px;\r\n\t}\r\n\r\n\t.iconContainer {\r\n\t\twidth: 36px;\r\n\t\theight: 36px;\r\n\t\tpadding: 6px;\r\n\t}\r\n\r\n\t.title {\r\n\t\tfont-size: 13px;\r\n\t}\r\n\r\n\t.message {\r\n\t\tfont-size: 12px;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationToast": `notificationToast_notificationToast__I1CV3`,
	"high": `notificationToast_high__yIx9Z`,
	"medium": `notificationToast_medium__s1sI1`,
	"low": `notificationToast_low__iMT7f`,
	"iconContainer": `notificationToast_iconContainer__XMQYQ`,
	"content": `notificationToast_content__Gyqaa`,
	"header": `notificationToast_header__Z5wA4`,
	"title": `notificationToast_title__J+iUC`,
	"message": `notificationToast_message__FSPYX`,
	"dismissBtn": `notificationToast_dismissBtn__YyGs1`
};
export default ___CSS_LOADER_EXPORT___;
